import { AcademicCapIcon, CheckIcon, ClipboardDocumentListIcon, MinusCircleIcon, NoSymbolIcon, QuestionMarkCircleIcon, UserIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { TooltipPortal, TooltipProvider } from '@radix-ui/react-tooltip';
import { WorkerStatus } from 'admin/src/components/enums/WorkerStatusEnum';
import type { ICellRendererParams } from 'ag-grid-enterprise';
import React from 'react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'shared/src/components/ui/new';

export const workerStatusContent = (status?: number) => {
  let content = '';
  let icon = <></>;

  switch (status) {
    case WorkerStatus.NOT_SPECIFIED:
      content = 'Not specified';
      icon = <XMarkIcon className="text-ev-red h-5 w-5" />;
      break;
    case WorkerStatus.ACTIVE:
      content = 'Active';
      icon = <CheckIcon className="text-green-600 size-4" />;
      break;
    case WorkerStatus.INACTIVE:
      content = 'Inactive';
      icon = <MinusCircleIcon className="text-blue-400 size-4" />;
      break;
    case WorkerStatus.RETIRED:
      content = 'Retired';
      icon = <AcademicCapIcon className="text-purple-600 size-4" />;
      break;
    case WorkerStatus.DO_NOT_USE:
      content = 'Do Not Use';
      icon = <NoSymbolIcon className="text-red-600 size-4" />;
      break;
    case WorkerStatus.INCOMPLETE_REGISTRATION:
      content = 'Incomplete Registration';
      icon = <ClipboardDocumentListIcon className="text-orange-400 size-4" />;
      break;
    case WorkerStatus.REGISTRATION_COMPLETED:
      content = 'Registration Completed';
      icon = <ClipboardDocumentListIcon className="text-green-600 size-4" />;
      break;
    case WorkerStatus.PROSPECT:
      content = 'Prospect';
      icon = <UserIcon className="text-teal-500 size-4" />;
      break;
    default:
      content = 'Unknown';
      icon = <QuestionMarkCircleIcon className="text-pink-500 size-4" />;
      break;
  }

  return { content, icon };
};

export default function StatusCellRenderer({ params, filterDisplay }: { params: ICellRendererParams; filterDisplay?: boolean }) {
  const { icon, content } = workerStatusContent(params.value);

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger>
          <div className="flex items-center space-x-2">
            <div>{icon}</div>
            {filterDisplay ? <div>{content}</div> : null}
          </div>
        </TooltipTrigger>
        <TooltipPortal>
          <TooltipContent>{content}</TooltipContent>
        </TooltipPortal>
      </Tooltip>
    </TooltipProvider>
  );
}
